import React, { Fragment, useState, useEffect, useMemo } from "react";
import { Modal, Button, Form, Badge } from "react-bootstrap";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  loadSchoolsList,
  loadAssessmentsListBySchoolAssessment,
  loadAssessmentsList,
  loadClassroomsList,
  loadClassroomsStudentList,
  loadUsersList,
} from "../../actions/admin";
import {
  addAssessmentResult,
  clearAssessmentResult,
  addBulkAssessmentResult,
} from "../../actions/assessment";
import { retrieveSchoolYears } from "../../actions/admin";
import Loading from "../layouts/Loading";
import { useHistory } from "react-router-dom";
import MultiSelectWithCheckboxes from "../layouts/MultiSelect";
import ListGroup from "react-bootstrap/ListGroup";

const AssessmentCreate = ({
  user,
  isAuthenticated,
  loadUsersList,
  usersList,
  usersListLoading,
  loadSchoolsList,
  schoolsList,
  schoolsListLoading,
  loadAssessmentsListBySchoolAssessment,
  loadAssessmentsList,
  assessmentsList,
  assessmentListLoading,
  classroomsList,
  classroomListLoading,
  loadClassroomsList,
  loadClassroomsStudentList,
  classroomsStudentList,
  classroomsStudentListLoading,
  accessCode,
  addAssessmentResult,
  addBulkAssessmentResult,
  retrieveSchoolYears,
  schoolYears,
}) => {
  const hist = useHistory();
  const [formData, setFormData] = useState({
    SchoolID: "",
    GradeID: "",
    AssigningGradeID: "",
    StudentID: "",
    StudentIDs: [],
    AssessmentTypeIDs: [],
    AssessmentID: "",
    AssessmentIDs: [],
    BenchMarkID: "",
    BenchMarkIDs: [],
    ClassroomIDs: [],
    Year: schoolYears?.endYear || new Date().getFullYear() + 1,
  });

  const [grade, setGrade] = useState("");
  const [assigningGrade, setAssigningGrade] = useState("");
  const [school, setSchool] = useState("");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");
  const [active, setActiveStep] = useState(1);

  // Add Focus Handlers
  const handleStepFocus = (step) => {
    setActiveStep(step);
  };

  // Load school list
  useEffect(() => {
    if (user && isAuthenticated) {
      loadSchoolsList();
      console.log("Formdata student id: ", formData);
      if (formData?.SchoolID) {
        loadUsersList({ SchoolIDs: [formData?.SchoolID] });
      }
      loadClassroomsList();
      loadClassroomsStudentList();
    }
  }, [user, formData?.SchoolID]);

  // When user role is teacher, auto set school ID
  useEffect(() => {
    if (
      user &&
      user.SchoolID &&
      user.UserTypeID === 1 &&
      formData?.SchoolID === ""
    ) {
      setFormData((prevData) => ({
        ...prevData,
        SchoolID: user.SchoolID,
      }));
    }
  }, [user, formData?.SchoolID]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      Year: schoolYears?.endYear || new Date().getFullYear() + 1,
    }));
  }, [schoolYears]);

  useEffect(() => {
    if (!schoolYears || !schoolYears.endYear) {
      retrieveSchoolYears(new Date());
    }
  }, [schoolYears, retrieveSchoolYears]);

  // Load Assessment Belongs to the School
  useEffect(() => {
    if (formData?.SchoolID !== "") {
      loadAssessmentsListBySchoolAssessment(formData?.SchoolID);
    }
  }, [formData?.SchoolID]);

  // Cross-filter logic
  // Assessments
  const filteredAssessments = useMemo(() => {
    if (
      !assessmentsList ||
      assessmentsList.length === 0 ||
      !formData?.AssessmentTypeIDs ||
      formData?.AssessmentTypeIDs.length === 0 ||
      formData?.BenchMarkID === ""
    )
      return [];

    return assessmentsList.filter((assessment) => {
      // Filter by school if selected
      const schoolMatch =
        !formData?.SchoolID ||
        formData?.SchoolID === "" ||
        assessment.SchoolID === formData?.SchoolID;

      // Filter by grade if selected
      const gradeMatch =
        !formData?.AssigningGradeID ||
        formData?.AssigningGradeID === "" ||
        assessment.GradeID === formData?.AssigningGradeID;

      // Filter by assessment types if selected
      const assessmentTypeMatch =
        formData?.AssessmentTypeIDs.length === 0 ||
        formData?.AssessmentTypeIDs.includes(assessment.CategoryID);

      // Filter by BenchMarkID
      const becnhMarkMatch =
        !formData?.BenchMarkID ||
        formData?.BenchMarkID === "" ||
        assessment.BenchMarkID === formData?.BenchMarkID;

      return (
        schoolMatch &&
        gradeMatch &&
        assessmentTypeMatch &&
        becnhMarkMatch &&
        assessment.IsProgressMonitoring === false
      );
    });
  }, [
    assessmentsList,
    formData?.SchoolID,
    formData?.AssigningGradeID,
    formData?.AssessmentTypeIDs,
    formData?.BenchMarkID,
  ]);

  console.log("Form data Benchmark: ", formData.BenchMarkID);

  // Classrooms
  const filteredClassrooms = useMemo(() => {
    if (
      !classroomsList ||
      classroomsList.length === 0 ||
      !formData?.SchoolID ||
      !formData?.SchoolID === ""
    )
      return [];

    return classroomsList.filter((classroom) => {
      // Filter by school if selected
      const schoolMatch =
        !formData?.SchoolID ||
        formData?.SchoolID === "" ||
        classroom.SchoolID === formData?.SchoolID;

      // Filter by grade if selected

      const gradeMatch =
        !formData?.GradeID ||
        formData?.GradeID === "" ||
        classroom.GradeID === formData?.GradeID;

      // Filter by year if selected
      const yearMatch =
        !formData?.Year ||
        formData?.Year === "" ||
        classroom.Year === formData?.Year;

      // Filter by teacher if user is teacher
      let teacherMatch = true;
      if (user.UserTypeID === 1) {
        teacherMatch = classroom.TeacherID === user.UserID;
      }

      return schoolMatch && gradeMatch && yearMatch && teacherMatch;
    });
  }, [
    user,
    classroomsList,
    formData?.SchoolID,
    formData?.GradeID,
    formData?.Year,
  ]);

  // Students
  const filteredStudents = useMemo(() => {
    if (
      !formData?.ClassroomIDs ||
      formData?.ClassroomIDs.length === 0 ||
      !classroomsStudentList ||
      classroomsStudentList.length === 0
    )
      return [];

    return classroomsStudentList.filter((classroom) =>
      formData?.ClassroomIDs.includes(classroom.ClassroomID),
    );
  }, [formData?.SchoolID, formData?.ClassroomIDs]);

  const validateForm = () => {
    if (formData?.SchoolID === "") {
      setWarningMessage("School is required");
      setShowWarning(true);
      return false;
    }

    if (!formData?.Year || formData?.Year === "") {
      setWarningMessage("Year is required");
      setShowWarning(true);
      return false;
    }

    if (formData?.GradeID === "") {
      setWarningMessage("Grade is required");
      setShowWarning(true);
      return false;
    }

    if (!formData?.ClassroomIDs || formData?.ClassroomIDs.length === 0) {
      setWarningMessage("At least one classroom must be selected");
      setShowWarning(true);
      return false;
    }

    if (!formData?.StudentIDs || formData?.StudentIDs.length === 0) {
      setWarningMessage("At least one student must be selected");
      setShowWarning(true);
      return false;
    }

    if (!formData?.AssigningGradeID || formData?.AssigningGradeID === "") {
      setWarningMessage("Assigning Grade is required");
      setShowWarning(true);
      return false;
    }

    if (!formData?.BenchMarkID || formData?.BenchMarkID === "") {
      setWarningMessage("Benchmark is required");
      setShowWarning(true);
      return false;
    }

    if (
      !formData?.AssessmentTypeIDs ||
      formData?.AssessmentTypeIDs.length === 0
    ) {
      setWarningMessage("At least one assessment type must be selected");
      setShowWarning(true);
      return false;
    }

    if (!formData?.AssessmentIDs || formData?.AssessmentIDs.length === 0) {
      setWarningMessage("At least one assessment must be selected");
      setShowWarning(true);
      return false;
    }

    return true;
  };

  // Add this function to handle the confirmation
  const handleConfirmAssignment = async () => {
    try {
      addBulkAssessmentResult(formData).then((res) => {
        if (res && res.length) {
          const msgStr = res.map((msg) => msg).join("\n");
          setWarningMessage(msgStr);
          setShowWarning(true);
          return;
        } else {
          // Reset form
          setFormData({
            SchoolID: "",
            GradeID: "",
            AssigningGradeID: "",
            StudentID: "",
            StudentIDs: [],
            AssessmentTypeIDs: [],
            AssessmentID: "",
            AssessmentIDs: [],
            BenchMarkID: 1,
            BenchMarkIDs: [],
            ClassroomIDs: [],
            Year: new Date().getFullYear() + 1,
          });
          setShowConfirmModal(false);
          // Navigate to results page
          setTimeout(() => {
            hist.push("/admin/result");
          }, 2000);
        }
      });
    } catch (error) {
      console.error("Error creating assessment assignments:", error);
      setWarningMessage("An error occurred while creating assignments.");
      setShowWarning(true);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();

    // Validate form data
    if (!validateForm()) {
      return;
    }

    setShowConfirmModal(true);
  };

  const onChange = (e) => {
    console.log("test value on change", e.target.value);
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const { StudentID, StudentIDs, AssessmentID, BenchMarkID, Year } = formData;

  return (
    <Fragment>
      {/* && !usersListLoading */}
      {user !== null && isAuthenticated ? (
        <div className=" container mx-auto my-5" style={{ paddingTop: "80px" }}>
          <div className="mb-3">
            <div className="d-sm-flex  w-100 align-items-center justify-content-between">
              <div className="d-flex mb-2 mb-sm-0">
                <div
                  className="admin-back mx-2  rounded-circle d-flex align-items-center justify-content-center txt-primary"
                  onClick={() => {
                    hist.goBack();
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    fill="currentColor"
                    className="bi bi-arrow-left-short"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
                    />
                  </svg>
                </div>
                <h4 className="m-0">Assessment</h4>
              </div>
            </div>
          </div>
          <div className="d-flex  position-relative ">
            <div className="container card shadow border-0 w-100 ">
              <div className="card-body  mt-1">
                <h4>Assign Assessment</h4>
                <form onSubmit={(e) => onSubmit(e)}>
                  <ListGroup>
                    {/* Basic Information Section */}
                    <ListGroup.Item className="p-0">
                      {/* Section Header & Description */}
                      <div
                        className={`${
                          active === 1 && "bg-primary text-white"
                        } px-3 py-1 border-bottom`}
                      >
                        <h6 className="mt-2">
                          Step 1: Identifying Information
                        </h6>
                        <p className="mt-2">
                          Please provide the basic information for the
                          assessment(s).
                        </p>
                      </div>

                      {/* Section Details */}
                      <div className="row g-3 p-3 mb-3">
                        {/* School */}
                        {user.UserTypeID === 6 && !schoolsListLoading && (
                          <div
                            className="col-md-4 mt-3"
                            onFocus={() => handleStepFocus(1)}
                          >
                            <label for="inputAssessment">
                              <b>School</b>
                            </label>
                            <MultiSelectWithCheckboxes
                              id="SchoolID"
                              value={formData?.SchoolID || school}
                              optionsList={user.schoolIds
                                .split(",")
                                .map((id) => ({
                                  value: parseInt(id),
                                  label:
                                    usersList.filter(
                                      (school) =>
                                        school.SchoolID === parseInt(id),
                                    )[0]?.SchoolName || "Unknown School",
                                }))}
                              placeholder={"Select School"}
                              formData={formData}
                              setFormData={setFormData}
                              isMulti={false}
                              showSelectAll={false}
                            />
                          </div>
                        )}

                        {/* School */}
                        {user.UserTypeID === 5 && !schoolsListLoading && (
                          <div
                            className="col-md-4 mt-3"
                            onFocus={() => handleStepFocus(1)}
                          >
                            <label for="inputAssessment">
                              <b>School</b>
                            </label>
                            <MultiSelectWithCheckboxes
                              id="SchoolID"
                              value={formData?.SchoolID || school}
                              optionsList={[
                                { value: "", label: "Please Select a School" },
                                ...schoolsList.map((school) => ({
                                  value: school.SchoolID,
                                  label: school.Name,
                                })),
                              ]}
                              placeholder={"Select School"}
                              formData={formData}
                              setFormData={setFormData}
                              isMulti={false}
                              showSelectAll={false}
                            />
                          </div>
                        )}

                        {/* School */}
                        {user.UserTypeID === 1 && !schoolsListLoading && (
                          <div
                            className="col-md-4 mt-3"
                            onFocus={() => handleStepFocus(1)}
                          >
                            <label for="inputAssessment">
                              <b>School</b>
                            </label>
                            <MultiSelectWithCheckboxes
                              id="SchoolID"
                              value={formData?.SchoolID || user.SchoolID}
                              optionsList={[
                                { value: "", label: "Please Select a School" },
                                ...schoolsList
                                  .filter(
                                    (school) =>
                                      school.SchoolID === user.SchoolID,
                                  )
                                  .map((school) => ({
                                    value: school.SchoolID,
                                    label: school.Name,
                                  })),
                              ]}
                              placeholder={"Select School"}
                              formData={formData}
                              setFormData={setFormData}
                              isMulti={false}
                              showSelectAll={false}
                            />
                          </div>
                        )}

                        {/* Year */}
                        <div
                          className="col-md-4 mt-3"
                          onFocus={() => handleStepFocus(1)}
                        >
                          <label for="inputAssessment">
                            <b>Year</b>
                          </label>
                          <MultiSelectWithCheckboxes
                            id="Year"
                            value={formData?.Year}
                            optionsList={(() => {
                              const startYear = 2020;
                              const currentYear =
                                schoolYears?.endYear ||
                                new Date().getFullYear() + 1;
                              let options = [
                                { value: "", label: "Please Select a Year" },
                              ];

                              // If user type is 1, show only current year option
                              if (user.UserTypeID === 1) {
                                options.push({
                                  value: currentYear,
                                  label: `${currentYear - 1}-${currentYear}`,
                                });
                              } else {
                                for (let i = startYear; i < currentYear; i++) {
                                  options.push({
                                    value: i + 1, // use endYear so it matches formData?.Year
                                    label: `${i}-${i + 1}`,
                                  });
                                }
                              }

                              return options;
                            })()}
                            placeholder={"Select Year"}
                            formData={formData}
                            setFormData={setFormData}
                            isMulti={false}
                            showSelectAll={false}
                          />
                        </div>

                        {/* Grade */}
                        <div
                          className="col-md-4 mt-3"
                          onFocus={() => handleStepFocus(1)}
                        >
                          <label for="inputAssessment">
                            <b>Grade</b>
                          </label>
                          <MultiSelectWithCheckboxes
                            id="GradeID"
                            value={formData?.GradeID || grade}
                            optionsList={
                              user.UserTypeID === 1
                                ? [
                                    { value: "", label: "All Grades" },
                                    ...Array.from(
                                      new Map(
                                        (classroomsList || [])
                                          .filter(
                                            (classroom) =>
                                              classroom.Year ===
                                                (schoolYears?.endYear ||
                                                  new Date().getFullYear() +
                                                    1) &&
                                              classroom.TeacherID ===
                                                user.UserID,
                                          )
                                          .map((classroom) => [
                                            classroom.GradeID,
                                            {
                                              value: classroom.GradeID,
                                              label: classroom.Grade,
                                            },
                                          ]),
                                      ).values(),
                                    ),
                                  ]
                                : [
                                    // {
                                    //   value: "",
                                    //   label: "Please Select a Grade",
                                    // },
                                    { value: 7, label: "Kindergarten" },
                                    { value: 1, label: "Grade 1" },
                                    { value: 2, label: "Grade 2" },
                                    { value: 3, label: "Grade 3" },
                                    { value: 4, label: "Grade 4" },
                                    { value: 5, label: "Grade 5" },
                                    { value: 6, label: "Grade 6" },
                                    { value: 8, label: "Grade 7" },
                                    { value: 9, label: "Grade 8" },
                                    { value: 10, label: "Other" },
                                  ]
                            }
                            placeholder={"Select Grade"}
                            formData={formData}
                            setFormData={setFormData}
                            isMulti={false}
                            showSelectAll={false}
                          />
                        </div>

                        {/* Classroom - Super Admin / Admin */}
                        {(user.UserTypeID === 5 ||
                          user.UserTypeID === 6 ||
                          user.UserTypeID === 1) && (
                          <div
                            className="col-md-4 mt-3"
                            onFocus={() => handleStepFocus(1)}
                          >
                            <label for="inputAssessment">
                              <b>Classroom</b>
                            </label>
                            <MultiSelectWithCheckboxes
                              id="ClassroomIDs"
                              disabled={false}
                              value={formData?.ClassroomIDs || []}
                              optionsList={[
                                // { value: "", label: "Select/Deselect all" },
                                ...filteredClassrooms.map((classroom) => ({
                                  value: classroom.ClassroomID,
                                  label:
                                    classroom.Grade +
                                    " - " +
                                    classroom.Section +
                                    ` (${classroom.Year})`,
                                })),
                              ]}
                              placeholder={"Select Classrooms"}
                              formData={formData}
                              setFormData={setFormData}
                              isMulti={true}
                              showSelectAll={true}
                            />
                          </div>
                        )}

                        {/* Student */}
                        <div
                          className="col-md-4 mt-3"
                          onFocus={() => handleStepFocus(1)}
                        >
                          <label for="inputGrade">
                            <b>Student</b>
                          </label>
                          <MultiSelectWithCheckboxes
                            disabled={false}
                            id="StudentIDs"
                            value={StudentIDs}
                            optionsList={[
                              // { value: "", label: "Select/Deselect all" },
                              ...filteredStudents.map((student) => ({
                                value: student.StudentID,
                                label: `${student.StudentName} ${student.StudentLastName} - ${student.AlternativeID}`,
                              })),
                            ]}
                            placeholder={"Select Students"}
                            formData={formData}
                            setFormData={setFormData}
                            isMulti={true}
                            showSelectAll={true}
                          />
                        </div>
                      </div>
                    </ListGroup.Item>

                    {/* Assessment Assignment*/}
                    <ListGroup.Item className="p-0">
                      {/* Section Header & Description  */}
                      <div
                        className={`${
                          active === 2 && "bg-primary text-white"
                        } px-3 py-1 border-bottom`}
                      >
                        <h6 className="mt-2">Step 2: Assessment Assignment</h6>
                        <p className="mt-2">
                          Please select the assessment(s) and its configuration.
                        </p>
                      </div>
                      {/* Section Details */}
                      <div className="row g-3 p-3 mb-3">
                        {/* Assigning Grade */}
                        <div
                          className="col-md-4 mt-3"
                          onFocus={() => handleStepFocus(2)}
                        >
                          <label for="inputAssessment">
                            <b>Assigning Grade</b>
                          </label>
                          <MultiSelectWithCheckboxes
                            id="AssigningGradeID"
                            value={formData?.AssigningGradeID || assigningGrade}
                            optionsList={[
                              // {
                              //   value: "",
                              //   label: "Please Select a Grade",
                              // },
                              { value: 7, label: "Kindergarten" },
                              { value: 1, label: "Grade 1" },
                              { value: 2, label: "Grade 2" },
                              { value: 3, label: "Grade 3" },
                              { value: 4, label: "Grade 4" },
                              { value: 5, label: "Grade 5" },
                              { value: 6, label: "Grade 6" },
                              { value: 8, label: "Grade 7" },
                              { value: 9, label: "Grade 8" },
                              { value: 10, label: "Other" },
                            ]}
                            placeholder={"Select Grade"}
                            formData={formData}
                            setFormData={setFormData}
                            isMulti={false}
                            showSelectAll={false}
                          />
                        </div>

                        {/* Benchmark */}
                        <div
                          className="col-md-4 mt-3"
                          onFocus={() => handleStepFocus(2)}
                        >
                          <label for="inputAssessment">
                            <b>Benchmark</b>
                          </label>
                          <MultiSelectWithCheckboxes
                            id="BenchMarkID"
                            value={formData?.BenchMarkID || ""}
                            optionsList={[
                              {
                                value: "",
                                label: "Please Select a Benchmark",
                              },
                              { value: 1, label: "Benchmark – Fall" },
                              { value: 2, label: "Benchmark – Winter" },
                              { value: 3, label: "Benchmark – Spring" },
                              // { value: 4, label: "Progress Monitoring" },
                            ]}
                            placeholder={"Select a Benchmark"}
                            formData={formData}
                            setFormData={setFormData}
                            isMulti={false}
                            showSelectAll={false}
                          />
                        </div>
                        {/* Assessment Type */}
                        <div
                          className="col-md-4 mt-3"
                          onFocus={() => handleStepFocus(2)}
                        >
                          <label htmlFor="assessmentTypeIDs">
                            <b>Assessment Type</b>
                          </label>
                          <MultiSelectWithCheckboxes
                            id="AssessmentTypeIDs"
                            value={formData?.AssessmentTypeIDs || []}
                            optionsList={[
                              // { value: "", label: "Select/Deselect all" },
                              { value: 2, label: "Letter Sounds" },
                              { value: 1, label: "Name the Letter" },
                              { value: 3, label: "Story Reading" },
                              { value: 4, label: "Silly Words" },
                              { value: 5, label: "Break up the word" },
                              { value: 6, label: "Say the first Sound" },
                            ]}
                            placeholder={"Select Assessment Types"}
                            formData={formData}
                            setFormData={setFormData}
                            isMulti={true}
                            showSelectAll={true}
                          />
                        </div>

                        {/* Assessment */}
                        <div
                          className="col-md-4 mt-3"
                          onFocus={() => handleStepFocus(2)}
                        >
                          <label for="inputAssessment">
                            <b>Assessment</b>
                          </label>
                          <MultiSelectWithCheckboxes
                            id="AssessmentIDs"
                            value={formData?.AssessmentIDs || []}
                            optionsList={[
                              ...(filteredAssessments || []) // Safeguard against null/undefined array
                                .filter(
                                  (assessment) =>
                                    assessment && assessment.Title,
                                ) // Safeguard against missing Titles
                                .sort((a, b) => {
                                  const nameA = (a.Title || "").trim();
                                  const nameB = (b.Title || "").trim();
                                  return nameA.localeCompare(nameB); // Cleaner and safer string comparison
                                })
                                .map((assessment) => ({
                                  value: `${assessment.AssessmentID || ""}/${assessment.CategoryID || ""}`,
                                  label: `${assessment.Title || ""} (${assessment.Category || ""})`,
                                })),
                            ]}
                            placeholder={"Select Assessments"}
                            formData={formData}
                            setFormData={setFormData}
                            isMulti={true}
                            showSelectAll={true}
                          />
                        </div>
                      </div>
                    </ListGroup.Item>
                  </ListGroup>

                  {/* Action Area */}
                  <div className="d-flex align-items-center justify-content-end my-3">
                    <Button
                      type="submit"
                      size="sm"
                      className={`button-primary px-5`}
                    >
                      Assign
                    </Button>
                  </div>
                  {/* <div className="text-center my-2">
                    Use this{" "}
                    <a
                      href={`https://www.academicassessments.ca/assessment/join`}
                      className="txt-primary"
                    >
                      https://www.academicassessments.ca/assessment/join
                    </a>{" "}
                    to enter the Access Code and start the assessment.
                  </div>
                  {accessCode !== null && (
                    <div className="text-center my-2">
                      <h5 className="text-center">Access Code: {accessCode}</h5>
                    </div>
                  )} */}
                </form>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="d-flex align-items-center h-100 justify-content-center">
          <Loading />
        </div>
      )}

      {/* Modal: Confirm assign assessment */}
      {/* React Bootstrap Modal */}
      <Modal
        show={showConfirmModal}
        onHide={() => setShowConfirmModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Assessment Assignment</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="mb-3">
            <p className="text-muted">
              Please review the assessment details before confirming the
              assignment.
            </p>
          </div>

          {/* School Information */}
          {formData?.SchoolID && (
            <div className="mb-3">
              <Form.Label>
                <strong>School</strong>
              </Form.Label>
              <div className="p-2 bg-light rounded">
                {user?.UserTypeID === 5
                  ? schoolsList?.find(
                      (school) =>
                        school.SchoolID === parseInt(formData?.SchoolID),
                    )?.Name || "Unknown School"
                  : user?.UserTypeID === 6
                    ? usersList?.find(
                        (school) =>
                          school.SchoolID === parseInt(formData?.SchoolID),
                      )?.SchoolName || "Unknown School"
                    : user?.UserTypeID === 1
                      ? usersList?.find(
                          (school) =>
                            school.SchoolID === parseInt(formData?.SchoolID),
                        )?.SchoolName || "Unknown School"
                      : "N/A"}
              </div>
            </div>
          )}

          {/* Year */}
          <div className="mb-3">
            <Form.Label>
              <strong>Academic Year</strong>
            </Form.Label>
            <div className="p-2 bg-light rounded">
              {formData?.Year
                ? `${formData?.Year - 1}-${formData?.Year}`
                : "Not specified"}
            </div>
          </div>

          {/* Grade */}
          {formData?.GradeID && (
            <div className="mb-3">
              <Form.Label>
                <strong>Grade</strong>
              </Form.Label>
              <div className="p-2 bg-light rounded">
                {formData?.GradeID === ""
                  ? "All Grades"
                  : formData?.GradeID >= 1 && formData?.GradeID <= 6
                    ? `Grade ${formData?.GradeID}`
                    : formData?.GradeID === 7
                      ? "Kindergarten"
                      : formData?.GradeID === 8
                        ? "Grade 7"
                        : formData?.GradeID === 9
                          ? "Grade 8"
                          : formData?.GradeID === 10
                            ? "Other"
                            : "Not specified"}
              </div>
            </div>
          )}

          {/* Assigning Grade */}
          {formData?.GradeID && (
            <div className="mb-3">
              <Form.Label>
                <strong>Assigning Grade</strong>
              </Form.Label>
              <div className="p-2 bg-light rounded">
                {formData?.AssigningGradeID === ""
                  ? "All Grades"
                  : formData?.AssigningGradeID >= 1 &&
                      formData?.AssigningGradeID <= 6
                    ? `Grade ${formData?.AssigningGradeID}`
                    : formData?.AssigningGradeID === 7
                      ? "Kindergarten"
                      : formData?.AssigningGradeID === 8
                        ? "Grade 7"
                        : formData?.AssigningGradeID === 9
                          ? "Grade 8"
                          : formData?.AssigningGradeID === 10
                            ? "Other"
                            : "Not specified"}
              </div>
            </div>
          )}

          {/* Selected Benchmarks */}
          <div className="mb-3">
            <Form.Label>
              <strong>Benchmark</strong>
            </Form.Label>
            <div className="p-2 bg-light rounded">
              {formData?.BenchMarkID === ""
                ? "Please Select a Benchmark"
                : `${
                    {
                      1: "Benchmark 1 – Fall",
                      2: "Benchmark 2 – Winter",
                      3: "Benchmark 3 – Spring",
                      4: "Progress Monitoring",
                    }[formData?.BenchMarkID] || "Unknown Benchmark"
                  }`}
            </div>
          </div>

          {/* Assessment Types */}
          {formData?.AssessmentTypeIDs.length > 0 && (
            <div className="mb-3">
              <Form.Label>
                <strong>Assessment Types</strong>
              </Form.Label>
              <div className="p-2 bg-light rounded">
                <div className="d-flex flex-wrap gap-1">
                  {formData?.AssessmentTypeIDs.map((typeId) => {
                    const typeNames = {
                      1: "Name the Letter",
                      2: "Letter Sounds",
                      3: "Story Reading",
                      4: "Silly Words",
                      5: "Break up the word",
                      6: "Say the first Sound",
                    };
                    return (
                      <span
                        key={typeId}
                        className="badge me-1"
                        style={{
                          backgroundColor: "#18a587",
                          color: "#ffffff",
                          fontSize: "0.875rem",
                          fontWeight: "600",
                          padding: "0.5rem 0.75rem",
                          borderRadius: "0.375rem",
                        }}
                        role="status"
                        aria-label={`Assessment type: ${typeNames[typeId]}`}
                      >
                        {typeNames[typeId]}
                      </span>
                    );
                  })}
                </div>
              </div>
            </div>
          )}

          {/* Selected Assessments */}
          <div className="mb-3">
            <Form.Label>
              <strong>
                Selected Assessments ({formData?.AssessmentIDs.length})
              </strong>
            </Form.Label>
            <div
              className="p-2 bg-light rounded"
              style={{ maxHeight: "200px", overflowY: "auto" }}
            >
              {formData?.AssessmentIDs.length > 0 ? (
                <div className="d-flex flex-wrap gap-1">
                  {formData?.AssessmentIDs.map((assessmentId) => {
                    const assessment = assessmentsList.find(
                      (a) => a.AssessmentID === assessmentId.split("/")[0],
                    );
                    return assessment ? (
                      <span
                        key={assessmentId}
                        className="badge me-1 mb-1"
                        style={{
                          backgroundColor: "#18a587",
                          color: "#ffffff",
                          fontSize: "0.875rem",
                          fontWeight: "600",
                          padding: "0.5rem 0.75rem",
                          borderRadius: "0.375rem",
                        }}
                        role="status"
                        aria-label={`Assessment: ${assessment.Title} in category ${assessment.Category}`}
                      >
                        {assessment.Title} ({assessment.Category})
                      </span>
                    ) : null;
                  })}
                </div>
              ) : (
                <span className="text-muted">No assessments selected</span>
              )}
            </div>
          </div>

          {/* Selected Classrooms */}
          {formData?.ClassroomIDs.length > 0 && (
            <div className="mb-3">
              <Form.Label>
                <strong>
                  Selected Classrooms ({formData?.ClassroomIDs.length})
                </strong>
              </Form.Label>
              <div className="p-2 bg-light rounded">
                <div className="d-flex flex-wrap gap-1">
                  {formData?.ClassroomIDs.map((classroomId) => {
                    const classroom = filteredClassrooms.find(
                      (c) => c.ClassroomID === classroomId,
                    );
                    return classroom ? (
                      <span
                        key={classroomId}
                        className="badge me-1 mb-1"
                        style={{
                          backgroundColor: "#18a587",
                          color: "#ffffff",
                          fontSize: "0.875rem",
                          fontWeight: "600",
                          padding: "0.5rem 0.75rem",
                          borderRadius: "0.375rem",
                        }}
                        role="status"
                        aria-label={`Classroom: Grade ${classroom.Grade}, Section ${classroom.Section}, Year ${classroom.Year}`}
                      >
                        {classroom.Grade} - {classroom.Section} (
                        {classroom.Year})
                      </span>
                    ) : null;
                  })}
                </div>
              </div>
            </div>
          )}

          {/* Selected Students */}
          <div className="mb-3">
            <Form.Label>
              <strong>Selected Students ({formData?.StudentIDs.length})</strong>
            </Form.Label>
            <div
              className="p-2 bg-light rounded"
              style={{ maxHeight: "200px", overflowY: "auto" }}
            >
              {formData?.StudentIDs.length > 0 ? (
                <div className="d-flex flex-wrap gap-1">
                  {formData?.StudentIDs.map((studentId) => {
                    const student = filteredStudents.find(
                      (s) => s.StudentID === studentId,
                    );
                    return student ? (
                      <span
                        key={studentId}
                        className="badge me-1 mb-1"
                        style={{
                          backgroundColor: "#18a587",
                          color: "#ffffff",
                          fontSize: "0.875rem",
                          fontWeight: "600",
                          padding: "0.5rem 0.75rem",
                          borderRadius: "0.375rem",
                        }}
                        role="status"
                        aria-label={`Student: ${student.StudentName} ${
                          student.StudentLastName
                        }${
                          student.AlternativeID
                            ? `, ID: ${student.AlternativeID}`
                            : ""
                        }`}
                      >
                        {student.StudentName} {student.StudentLastName}
                        {student.AlternativeID && ` - ${student.AlternativeID}`}
                      </span>
                    ) : null;
                  })}
                </div>
              ) : (
                <span className="text-muted">No students selected</span>
              )}
            </div>
          </div>

          {/* Warning Message */}
          <div className="alert alert-warning mt-4">
            <strong>⚠️ Important:</strong> Once assigned, the assessment cannot
            be changed.
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowConfirmModal(false)}
          >
            Cancel
          </Button>
          <Button className="button-primary" onClick={handleConfirmAssignment}>
            Confirm Assignment
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Warning Modal */}
      {showWarning && warningMessage && (
        <Modal show={showWarning} onHide={() => setShowWarning(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Warning</Modal.Title>
          </Modal.Header>
          <Modal.Body className="d-flex flex-column gap-2">
            {warningMessage.split("\n").map((line, idx) => (
              <div key={idx}>{line}</div>
            ))}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowWarning(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </Fragment>
  );
};

AssessmentCreate.propTypes = {
  user: PropTypes.object,
  isAuthenticated: PropTypes.bool.isRequired,
  addAssessmentResult: PropTypes.func.isRequired,
  addBulkAssessmentResult: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  user: state.auth.user,
  isAuthenticated: state.auth.isAuthenticated,
  usersList: state.admin.usersList,
  usersListLoading: state.admin.usersListLoading,
  schoolsList: state.admin.schoolsList,
  schoolsListLoading: state.admin.schoolsListLoading,
  assessmentsList: state.admin.assessmentsList,
  assessmentListLoading: state.admin.assessmentListLoading,
  classroomsList: state.admin.classroomsList,
  classroomListLoading: state.admin.classroomListLoading,
  classroomsStudentList: state.admin.classroomsStudentList,
  classroomsStudentListLoading: state.admin.classroomsStudentListLoading,
  accessCode: state.assessment.accessCode,
  clearAdmin: state.admin.clearAdmin,
  schoolYears: state.admin.schoolYears,
});

export default connect(mapStateToProps, {
  loadUsersList,
  loadSchoolsList,
  loadAssessmentsListBySchoolAssessment,
  loadAssessmentsList,
  addAssessmentResult,
  addBulkAssessmentResult,
  loadClassroomsList,
  loadClassroomsStudentList,
  retrieveSchoolYears,
})(AssessmentCreate);
